import React from 'react'
import { Batch } from './BatchTracingForm'
import { DataTable } from '../../components'

interface Props {
  batchGroups: Batch[]
  searchByProperty: string
  searchByPropertyValue: string
}

interface Column {
  title: string
}

interface TableProps {
  columns: Column[]
  propertyNames: string[]
}

interface TablePropsBasedOnSearchProps {
  [searchProperty: string]: TableProps
}

const TABLE_PROPS_BASED_ON_SEARCH_PROPS: TablePropsBasedOnSearchProps = {
  order: {
    columns: [
      { title: 'Batch number' },
      { title: 'Article number' },
      { title: 'Starting Serial Number' },
      { title: 'Ending Serial Number' },
      { title: 'Quantity' },
    ],
    propertyNames: ['batchNo', 'articleNo', 'startSerial', 'endSerial', 'qty'],
  },
  batch: {
    columns: [
      { title: 'Order number' },
      { title: 'Article number' },
      { title: 'Starting Serial Number' },
      { title: 'Ending Serial Number' },
      { title: 'Quantity' },
    ],
    propertyNames: ['orderNo', 'articleNo', 'startSerial', 'endSerial', 'qty'],
  },
}

export const BatchTracingResults: React.FunctionComponent<Props> = props => {
  const { searchByPropertyValue, batchGroups, searchByProperty } = props
  let header = `${batchGroups.reduce((totalQty: number, batch) => totalQty + +batch.qty, 0)} Serial No's | `
  header += searchByProperty === 'batch' ? 'Batch Number: ' : 'Order number: '
  header += searchByPropertyValue
  const tableProps: TableProps = TABLE_PROPS_BASED_ON_SEARCH_PROPS[searchByProperty]

  return (
    <div className="row animated fadeIn batch-no-results">
      <div className="col-md-offset-2 col-md-8">
        <DataTable
          heading={header}
          columns={tableProps.columns}
          data={batchGroups.map((batch: Batch) => tableProps.propertyNames.map(propName => batch[propName]))}
          keyIndex={2}
          showId={true}
          defaultSort={{ sortColumnIndex: 2 }}
        />
      </div>
    </div>
  )
}
